import { useState } from "react";
import "./chain.css";

export default function ChainMath(){

const [screen,setScreen]=useState("home");

const [digits,setDigits]=useState(2);
const [length,setLength]=useState(5);
const [time,setTime]=useState(2);
const [mode,setMode]=useState("mixed");

const [nums,setNums]=useState([]);
const [ops,setOps]=useState([]);
const [display,setDisplay]=useState("");
const [result,setResult]=useState(0);
const [answer,setAnswer]=useState("");
const [wrong,setWrong]=useState(false);

const sleep=ms=>new Promise(r=>setTimeout(r,ms));

function generate(){

let low=Math.pow(10,digits-1);
let high=Math.pow(10,digits)-1;

let n=[],o=[];

for(let i=0;i<length;i++){
n.push(Math.floor(Math.random()*(high-low+1))+low);

if(i<length-1){
if(mode==="add") o.push("+");
else if(mode==="sub") o.push("-");
else o.push(Math.random()>0.5?"+":"-");
}
}

let res=n[0];
o.forEach((x,i)=>x==="+"?res+=n[i+1]:res-=n[i+1]);

return {n,o,res};
}

async function start(newGame){

setAnswer("");
setWrong(false);

let data=newGame?generate():{n:nums,o:ops,res:result};

setNums(data.n);
setOps(data.o);
setResult(data.res);

setScreen("play");

await sleep(400);

for(let i=0;i<data.n.length;i++){
setDisplay(i===0?data.n[i]:data.o[i-1]+" "+data.n[i]);
await sleep(time*1000);
setDisplay("");
await sleep(300);
}

setDisplay("ANSWER");
}

function check(){
if(parseInt(answer)===result){
start(true);
}else{
setWrong(true);
}
}

/* HOME SCREEN */

if(screen==="home"){
return(

<div className="app">

<button className="start" onClick={()=>start(true)}>START</button>

<div className="cards">

<div className="card">
<h4># Digits</h4>
<input type="range" min="1" max="20" value={digits}
onChange={e=>setDigits(+e.target.value)}/>
<div className="val">{digits}</div>
</div>

<div className="card">
<h4>Length</h4>
<input type="range" min="2" max="200" value={length}
onChange={e=>setLength(+e.target.value)}/>
<div className="val">{length}</div>
</div>

<div className="card">
<h4>Time</h4>
<input type="range" min="1" max="5" step=".1" value={time}
onChange={e=>setTime(+e.target.value)}/>
<div className="val">{time}</div>
</div>

<div className="card">
<h4>Mode</h4>
<select onChange={e=>setMode(e.target.value)}>
<option value="add">Addition</option>
<option value="sub">Subtraction</option>
<option value="mixed">Mixed</option>
</select>
</div>

</div>

</div>
);
}

/* PLAY SCREEN */

return(

<div className="play">

<h1 className="big">{display}</h1>

{display==="ANSWER" &&
<>
<input className="ans" value={answer}
onChange={e=>setAnswer(e.target.value)}
placeholder="Enter Answer"/>

<button className="submit" onClick={check}>Submit</button>
</>
}

{wrong &&
<div className="options">
<button onClick={()=>start(false)}>Try Same</button>
<button onClick={()=>start(true)}>Next Problem</button>
</div>
}

</div>
);
}
